import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es una terapia de reemplazo hormonal?',
  a: 'No, son ajustes de estilo de vida que complementan cualquier tratamiento médico.'
}, {
  q: '¿Necesito comprar comida especial?',
  a: 'No, usarás alimentos comunes aplicados con una nueva estrategia de tiempo.'
}, {
  q: '¿Funciona si ya pasé la menopausia?',
  a: 'Sí, los micro-ajustes ayudan a estabilizar el cuerpo en cualquier etapa post-reproductiva.'
}, {
  q: '¿Es un libro largo?',
  a: 'No, es un kit de acción rápida diseñado para leerse y aplicarse en menos de 20 minutos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-ivory py-20 md:py-32" data-id="element-13">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-serif text-text-brown tracking-wide mb-4" data-id="element-16">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-[1px] bg-taupe mx-auto" data-id="element-17"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-taupe/30 rounded-sm bg-white overflow-hidden" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-20">
                <span className="font-serif text-xl text-text-brown pr-4" data-id="element-21">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-terracotta transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
              </button>
              <AnimatePresence data-id="element-23">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-24">
                    <div className="px-6 pb-5 text-text-brown-light font-light leading-relaxed" data-id="element-25">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}